import type { KidInCustomer } from '@brighterly/lib-core-types/kid/interfaces'

import { useCustomerStore } from '@stores/me/customer'
import { useKidStore } from '@stores/kid'
import { useDisciplineStore } from '@stores/discipline'

import { useKidRoutes } from '@composables/routes/kid-route.hook'

import amplitudeConfig from '@config/amplitude.json'

import { trackEvent } from '@tools/amplitude'

interface KidsMenuReturn {
  kids: ComputedRef<KidInCustomer[]>
  activeKid: ComputedRef<KidInCustomer | null>
  setRedirect: (kid: KidInCustomer) => void
}

export const useKidsMenu = (): KidsMenuReturn => {
  const customerStore = useCustomerStore()
  const kidStore = useKidStore()
  const disciplineStore = useDisciplineStore()

  const {
    getHomeMath,
    getHomeEla,
    isRouteDisciplineEla,
    isRouteDisciplineMath,
  } = useKidRoutes()

  const kids = computed(() => customerStore.customer?.kids || [])

  const activeKid = computed(() => {
    return kids.value.find(kid => kid.id === kidStore.activeKidId) || null
  })

  const setTrackEvent = (kidId: number, url: string | null): void => {
    trackEvent(amplitudeConfig.events.clickTab, {
      name: 'tab_kid_switcher',
      kid_id: kidId,
      href: url,
    })
  }

  const setRedirect = async (kid: KidInCustomer): Promise<void> => {
    const isPrevStateRouteDisciplineEla = isRouteDisciplineEla.value
    const isPrevStateRouteDisciplineMath = isRouteDisciplineMath.value

    await kidStore.setActiveKid(kid.id)

    if (disciplineStore.isEla) {
      const url = getHomeEla(kid.id)
      setTrackEvent(kid.id, url)
      await navigateTo(url)
    } else if (disciplineStore.isMath) {
      const url = getHomeMath(kid.id)
      setTrackEvent(kid.id, url)
      await navigateTo(url)
    } if (isPrevStateRouteDisciplineEla) {
      const url = getHomeEla(kid.id)
      setTrackEvent(kid.id, url)
      await navigateTo(url)
    } else if (isPrevStateRouteDisciplineMath) {
      const url = getHomeMath(kid.id)
      setTrackEvent(kid.id, url)
      await navigateTo(url)
    }
  }

  return {
    kids,
    activeKid,
    setRedirect,
  }
}
